'use strict';

import React from 'react'
import ReactDOM from 'react-dom'
import { Router, Route, Link, browserHistory } from 'react-router'
import OrLine from '../common/orLine'
import {localsMessages} from '../utility/getTemplateData'

let messages = localsMessages('guest/guestButton')

let PropTypes = React.PropTypes

export default React.createClass({

	propTypes:{
		label: React.PropTypes.string
	},

	getInitialState () {
		return {};
	},

	render () {

		let debitorcredit = messages.label && messages.label.debitorcredit

		return (
			<div>
				<div className="wrap_max_361">
					<OrLine />
				</div>
				<div className="col-xs-12 col-sm-12 col-md-12 text-center pp_guest_btn_wrapper">
					<a href="#" className="btn btn-primary pp_guest_btn" id="payWithGuest" onClick={this.props.handleGuest}>{debitorcredit}</a>
				</div>
			</div>
		);
	}
});



// WEBPACK FOOTER //
// ./guest/guestButton.js